import React from "react";

export const SearchIcon =() => {
    return <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
        <path
            d="M21.1667 11.9999C21.1667 6.93992 17.06 2.83325 12 2.83325C6.94001 2.83325 2.83334 6.93992 2.83334 11.9999C2.83334 17.0599 6.94001 21.1666 12 21.1666"
            stroke="white" strokeWidth="0.8" strokeLinecap="round"
            strokeLinejoin="round"/>
        <path
            d="M8.33335 3.75H9.25002C7.46252 9.10333 7.46252 14.8967 9.25002 20.25H8.33335"
            stroke="white" strokeWidth="0.8" strokeLinecap="round"
            strokeLinejoin="round"/>
        <path d="M14.75 3.75C15.6392 6.42667 16.0884 9.21333 16.0884 12" stroke="white"
              strokeWidth="0.8" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M3.75003 15.6667V14.75C6.4267 15.6392 9.21336 16.0884 12 16.0884"
              stroke="white" strokeWidth="0.8" strokeLinecap="round"
              strokeLinejoin="round"/>
        <path d="M3.75003 9.25005C9.10336 7.46255 14.8967 7.46255 20.25 9.25005"
              stroke="white" strokeWidth="0.8" strokeLinecap="round"
              strokeLinejoin="round"/>
        <path
            d="M17.6833 20.6167C19.3034 20.6167 20.6167 19.3034 20.6167 17.6833C20.6167 16.0633 19.3034 14.75 17.6833 14.75C16.0633 14.75 14.75 16.0633 14.75 17.6833C14.75 19.3034 16.0633 20.6167 17.6833 20.6167Z"
            stroke="white" strokeWidth="0.8" strokeLinecap="round"
            strokeLinejoin="round"/>
        <path d="M21.1667 21.1667L20.25 20.25" stroke="white" strokeWidth="0.8"
              strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
}